import { ReactComponent as ChevronRightIcon } from "assets/icons/chevron-right.svg";
import { ReactComponent as ExclamationCircleIcon } from "assets/icons/exclamation_circle.svg";
import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import { classNames } from "helpers/ClassNameHelper";
import { Input, PhytoViewType, Tooltip } from "modules/common";
import { handleKeyDown } from "modules/common/utils/keyboardUtils";
import React, { ReactNode, useMemo } from "react";

export interface PanelMenuItem {
    label: string;
    link: string;
    fullScreen?: boolean;
    newModule?: boolean;
    internalLink?: boolean;
    isDisabled?: boolean;
    description?: string;
    type?: PhytoViewType;
}
export interface PanelMenuProps {
    items?: PanelMenuItem[];
    selectedItem?: PanelMenuItem;
    hidden?: boolean;
    onItemClicked: (item: PanelMenuItem) => void;
    isInput?: boolean;
    setInput?: React.Dispatch<React.SetStateAction<string>>;
    input?: string;
    customInput?: ReactNode;
    isLeftIcon?: boolean;
    isRightIcon?: boolean;
}
export const PanelMenu: React.FC<PanelMenuProps> = ({
    items,
    selectedItem,
    hidden,
    onItemClicked,
    isInput,
    setInput,
    input,
    customInput,
    isLeftIcon,
    isRightIcon,
}) => {
    const containerClassesMemo = useMemo(
        () => classNames("panel-menu-container", hidden && "panel-menu-hidden"),
        [hidden]
    );

    const itemElementsMemo = useMemo(
        () =>
            items?.map(item => {
                const { label, newModule, fullScreen } = item;

                return (
                    <div
                        key={item.link}
                        className={classNames(
                            "panel-menu-item",
                            fullScreen && "panel-menu-item-full-screen",
                            selectedItem &&
                                item.link === selectedItem.link &&
                                "panel-menu-item-selected",
                            item.isDisabled && "panel-menu-item--disabled"
                        )}
                        onClick={() => onItemClicked(item)}
                        tabIndex={0}
                        onKeyDown={e => handleKeyDown(e, () => onItemClicked(item))}
                    >
                        <span className="panel-menu-item-label">{label}</span>
                        <div className="panel-menu-item-icon-group">
                            {newModule && (
                                <Tooltip
                                    tooltipText="Novi modul"
                                    tooltipPosition="left"
                                    id={`new-module-tooltip-${item.label}`}
                                >
                                    <ExclamationCircleIcon className="exclamation-icon" />
                                </Tooltip>
                            )}
                            <div className={classNames("panel-menu-icon", fullScreen && "circle")}>
                                <ChevronRightIcon />
                            </div>
                        </div>
                    </div>
                );
            }),
        [items, selectedItem]
    );

    if (hidden || !items?.length) return <></>;

    return (
        <div className={containerClassesMemo}>
            {customInput}
            {isInput && setInput && (
                <Input
                    id="panel-search"
                    type="text"
                    name="panel-search"
                    size="medium"
                    placeholder="Pretraži..."
                    onChange={e => setInput(e.target.value)}
                    value={input}
                    leftIcon={isLeftIcon ? <SearchIcon className="search-icon" /> : undefined}
                    rightIcon={isRightIcon ? <SearchIcon className="search-icon" /> : undefined}
                />
            )}
            <div className="panel-menu-items-container">{itemElementsMemo}</div>
        </div>
    );
};
